import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { numConvert, calculation } from '@/method';

const totalIndex = [3, 6, 10, 14, 15, 18, 22, 23, 27, 33, 34, 37];
const percentIndex = [37];
const nameList = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec", 'full'];

export const compute = (data, last) => {
    // 对应下历史数据
    const correspond = {
        0: "best",
        1: "packges",
        2: "commerce",
        5: "wholesale",
        8: "corporate",
        11: "government",
        12: "discounts",
        15: "total",
        16: "business",
        19: "leisure",
        23: "group_total",
        24: "contracts",
        31: "others",
        34: "grand",
    };
    nameList.forEach((name, i) => {
        const index = i * 3 + 1;
        Object.entries(correspond).forEach(item => {
            data[item[0]][`${name}_rn`] = _.get(last, `${index}.${item[1]}_rn`, 0);
            data[item[0]][`${name}_rev`] = _.get(last, `${index}.${item[1]}_rev`, 0);
        });
        data[35][`${name}_rn`] = _.get(last, `${index}.grand_rms`, 0);
    });


    const sumIndex = {
        3: [0, 1, 2],
        6: [4, 5],
        10: [7, 8, 9],
        14: [12, 13],
        15: [3, 6, 10, 11, 14],
        18: [16, 17],
        22: [19, 20, 21],
        23: [18, 22],
        27: [24, 25, 26],
        33: [28, 29, 30, 31, 32],
        34: [15, 23, 27, 28]
    }

    nameList.forEach(name => {
        if (name != 'full') {
            const rn = `${name}_rn`;
            const rev = `${name}_rev`;
            Object.entries(sumIndex).forEach(index => {
                data[index[0]][rn] = index[1].reduce((a, b) => a += numConvert(data[b][rn]), 0).toFixed(2);
                data[index[0]][rev] = [...index[1], ...(index[0] == 34 ? [31, 32] : [])].reduce((a, b) => a += numConvert(data[b][rev]), 0).toFixed(2);
            });
        }
    });
    data.forEach((item, index) => {
        data[index]['full_rn'] = nameList.reduce((a, b) => {
            if (b == 'full') return a;
            return (a + numConvert(item[`${b}_rn`]))
        }, 0).toFixed(2);
        data[index]['full_rev'] = nameList.reduce((a, b) => {
            if (b == 'full') return a;
            return (a + numConvert(item[`${b}_rev`]))
        }, 0).toFixed(2);
    });

    data.forEach((item, index) => {
        if (index != 37) nameList.forEach(name => {
            data[index][`${name}_adr`] = calculation(data[index][`${name}_rev`], data[index][`${name}_rn`]);
        });
    });

    nameList.forEach(name => {
        data[36][`${name}_rn`] = ~~(data[35][`${name}_rn`] - data[34][`${name}_rn`]);
        data[37][`${name}_rn`] = calculation(data[34][`${name}_rn`], data[35][`${name}_rn`], 4);
        data[37][`${name}_adr`] = calculation(data[34][`${name}_rev`], data[34][`${name}_rn`], 2);
        data[37][`${name}_rev`] = (data[37][`${name}_rn`] * data[37][`${name}_adr`]).toFixed(2);
    });

    return data;
}

export const columns = (onChange, date, type, print) => {
    // type 1 forecast 2 actual
    const month = moment(date).format('M');
    const year = moment(date).format('YYYY');
    const sqlName = type == 1 ? "_4new_4_3_1_forecast" : type == 2 ? "_4new_4_3_1_actual" : '_4new_4_3_1_budget';
    return [
        {
            title: year,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: print ? false : "left",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['name'],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        ...nameList.map((name, i) => {
            const title = type == 1 ? 'Forecast' : type == 2 ? 'Actual' : 'Budget';
            const childTitle = name == 'full' ? "FULL YEAR" : `${~~(i + 1)}月`;
            return {
                title: `${year} ${title}`,
                align: "center",
                width: 450,
                children: [{
                    title: childTitle,
                    align: "center",
                    width: 450,
                    children: [{
                        title: "RNs",
                        dataIndex: `${name}_rn`,
                        key: `${name}_rn`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = [title, childTitle, 'RNs'];
                            const props = {
                                text,
                                index,
                                type: percentIndex.includes(index) ? 'percent' : "number",
                                name: `${name}_rn`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }, {
                        title: "ADR",
                        dataIndex: `${name}_adr`,
                        key: `${name}_adr`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = [title, childTitle, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: "number",
                                name: `${name}_adr`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }, {
                        title: "REVENUE",
                        dataIndex: `${name}_rev`,
                        key: `${name}_rev`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = [title, childTitle, 'REVENUE'];
                            const props = {
                                text,
                                index,
                                type: "number",
                                name: `${name}_rev`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }]
                }],

            }
        })
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.1/history/compute.js